class SafeLocalStorage {
  static getItem(key: string, def: any): any {
    try {
      return localStorage.getItem(key)
    } catch (err) {
      if (typeof def === 'function') {
        return def(key)
      } else {
        return def
      }
    }
  }

  static setItem(key: string, value: any, callback?: (...args: any[]) => any): any {
    try {
      return localStorage.setItem(key, value)
    } catch (err) {
      if (typeof callback !== 'function') return

      return callback(key, value)
    }
  }
}

export default SafeLocalStorage
